
import { Component, Mixins } from 'vue-property-decorator';
import SearchBar from '~/components/SearchBar.vue';
import { ConfigModule } from '~/store/modules/config';
import { LayoutModule } from '~/store/modules/layout';
import { OperatorModule } from '~/store/modules/operator';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';
import { AppModule } from '~common-store/modules/app';

@Component({
    components: {
        SearchBar
    }
})
export default class TheAppBar extends Mixins(DarkThemeInfoMixin) {
    logout() {
        location.href = ConfigModule.logOutUrl + '?next_url=' + encodeURIComponent(window.location.href);
    }
    openOldDGM() {
        window.open(`/#${this.$route.path}`);
    }
    toggleSideMenuOpen() {
        LayoutModule.toggleSideMenuOpen();
    }
    get prefix() {
        return ConfigModule.environmentPrefix;
    }
    get app() {
        return AppModule.adminApp;
    }
    get environment() {

        return ConfigModule.environment;
    }
    get userEmail() {
        return OperatorModule.adminMail;
    }
    get environmentColor() {
        switch (this.environment) {
            case 'production':
                return 'primary';
            default:
                return 'secondary';
        }
    }

    get apiEnvironment() {
        return ConfigModule.apiEnvironment;
    }

    get userHasRights() {
        return Object.keys(OperatorModule.adminRights).length > 0;
    }
}
